import { __assign } from "tslib";
import React from 'react';
import { NotificationType, } from '../../redux/types';
import FaveNotification from '../../../FaveButton/FaveNotification';
import CollectNotification from '../../../CollectionPanel/CollectNotification';
import CommentDeleteNotification from '../../../Comment/DeleteNotification';
import GroupAddedNotification from '../../../AddToGroupsPanel/_partials/GroupAddedNotification';
import LiveNotification from '../../../LiveNotifications/LiveNotification';
var NotificationContent = function (_a) {
    var notification = _a.notification, removeNotification = _a.removeNotification, children = _a.children;
    if (!notification) {
        return null;
    }
    switch (notification.type) {
        case NotificationType.Collect:
        case NotificationType.CollectUndo:
            return (React.createElement(CollectNotification, __assign({ id: notification.id, queueName: notification.queueName, type: notification.type, removeNotification: removeNotification }, notification.params)));
        case NotificationType.Fave:
        case NotificationType.FaveUndo:
            return (React.createElement(FaveNotification, __assign({ id: notification.id, queueName: notification.queueName, type: notification.type, removeNotification: removeNotification }, notification.params)));
        case NotificationType.DeleteComment:
            return (React.createElement(CommentDeleteNotification, __assign({ id: notification.id, queueName: notification.queueName, type: notification.type, removeNotification: removeNotification }, notification.params)));
        case NotificationType.AddToGroup:
            return (React.createElement(GroupAddedNotification, __assign({ id: notification.id, queueName: notification.queueName }, notification.params)));
        case NotificationType.Live:
            return (React.createElement(LiveNotification, __assign({ id: notification.id, queueName: notification.queueName, notificationHtml: notification.params.message, linkTo: notification.params.url }, notification.params)));
        default:
            if (!children) {
                return null;
            }
            return React.createElement(React.Fragment, null, children(notification, removeNotification));
    }
};
NotificationContent.displayName = 'NotificationContent';
export default NotificationContent;
//# sourceMappingURL=NotificationContent.js.map